/*
 * @Author: your name
 * @Date: 2021-07-14 11:08:11
 * @LastEditTime: 2023-08-29 14:10:26
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\assets\scripts\rgbaAndHex.js
 */
// rgba 转化为16进制和10进制
export function rgbaToHex(rgba) {
  let Hex = {};
  let RGBAString = rgba;
  let rgbRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(0|(0(\.\d{0,2}))?|1)\)$/;
  let R = RGBAString.match(rgbRegex)[1] * 1;
  let G = RGBAString.match(rgbRegex)[2] * 1;
  let B = RGBAString.match(rgbRegex)[3] * 1;
  let A = RGBAString.match(rgbRegex)[4] * 1;
  // console.log(RGBAString.match(rgbRegex));
  // console.log(R + ', ' + G + ', ' + B + ', ' + A);
  let hex10 = (Math.round(A * 255) << 24) + (R << 16) + (G << 8) + B;
  let hex16 = hex10.toString(16);
  Hex.hex10 = hex10;
  Hex.hex16 = hex16;
  return Hex;
}

export function hexToRgba(hex) {
  let HEXString = hex * 1;
  let a = ((HEXString >> 24) & 0xFF) / 255;
  let R = (HEXString >> 16) & 0xFF;
  let G = (HEXString >> 8) & 0xFF;
  let B = (HEXString) & 0xFF;
  let A = a === 1 || a === 0 ? a.toFixed(0) : a.toFixed(1);
  let rgba = 'rgba(' + R + ', ' + G + ', ' + B + ', ' + A + ')';
  return rgba;
}
